import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import AnalyticsExportPdfStyles from './AnalyticsExportPdfStyles';
import AnalyticsExportPublicRoute from './AnalyticsExportPublicRoute';

export const publicAnalyticsExportsRouter: RouteObject = {
  path: routeConfig.public.routes.analyticsExports.path,
  element: (
    <>
      <AnalyticsExportPdfStyles />
      <Outlet />
    </>
  ),
  children: [
    {
      path: routeConfig.public.routes.analyticsExports.routes.view.path,
      element: <AnalyticsExportPublicRoute />,
    },
  ],
};
